'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var LANGUAGE_CHANGED = exports.LANGUAGE_CHANGED = '@wh/language-selector/LANGUAGE_CHANGED';
//# sourceMappingURL=constants.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/language-common/dist/main/constants.js
// module id = 261
// module chunks = 0